module.exports = __webpack_public_path__ + "static/media/selectedDraw.c2c0bd89.png";